import { useEffect, useRef } from 'react';
import { bridgeNativeOAuth } from '../nativeOAuthBridge';

const GoogleMyBusinessRedirect = () => {
    const intervalRef = useRef(null);
    const popupWindowURL = new URL(window.location.href);
    const urlParams = new URLSearchParams(popupWindowURL.search);
    var code = urlParams.get("code");
    var error = urlParams.get("error");
    var error_description = urlParams.get("error_description");
    var state = urlParams.get("state");
    useEffect(() => {
        if (bridgeNativeOAuth(state, 'gbusiness', code, error, error_description)) return;
        if (code || error) {
            // Store code or error in localStorage
            if (code) {
                localStorage.setItem("googleMyBusiness_token", code);
            } else {
                localStorage.setItem("googleMyBusiness_error", error_description || error);
            }

            // Notify parent window and close
            notifyParent(code || null);
            window.close();
            return; // Prevent interval setup if code/error is already handled
        }

        const checkAuthCode = () => {
            const storedCode = localStorage.getItem("googleMyBusiness_token");
            if (storedCode) {
                notifyParent(storedCode);
                clearInterval(intervalRef.current);
            }
        };
        intervalRef.current = setInterval(checkAuthCode, 5000);
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [code, error, error_description, state]);

    const notifyParent = (authCode) => {
        const message = { type: "googleMyBusiness_token", code: authCode };

        try {
            const iframe = document.getElementById("iframe-id");
            if (iframe?.contentWindow) {
                iframe.contentWindow.postMessage(message, "*");
            } else if (window.opener) {
                window.opener.postMessage(message, "*"); 
            }
        } catch (e) {
            console.error("Failed to send message to parent window:", e);
        }
    };

    return null;
};
export default GoogleMyBusinessRedirect;
